<template>
  <b-modal id="create-client-profile" title="Создание профиля клиента" @shown="shownModal" ok-only ok-title="Создать" @ok="createClient">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <b>Бренд:</b>
      <span>{{brandName}}</span>
    </div>
    <b-form-group
      label="Введите имя клиента"
      label-for="input-1"
      invalid-feedback="Имя клиента не может быть пустым"
      valid-feedback=""
      :state="validate"
    >
      <b-form-input id="input-1" v-model="clientName" :state="validate" trim></b-form-input>
    </b-form-group>
  </b-modal>
</template>

<script>
import {callCenterACT} from '../../constants/vuexActions'
import {callCenterGetters} from '../../constants/vuexGetters'

export default {
  name: 'CreateClientProfile',
  data () {
    return {
      clientName: '',
      vuexNamespace: 'callCenter'
    }
  },
  methods: {
    shownModal () {
      this.clientName = ''
    },
    openModal () {
      this.$bvModal.show('create-client-profile')
    },
    createClient (event) {
      if (!this.validate) {
        event.preventDefault()
      } else {
        this.$store.dispatch(`${this.vuexNamespace}/${callCenterACT.CREATE_CLIENT_PROFILE}`, this.clientName).then(res => {
          this.$bvModal.hide('create-client-profile')
        })
      }
    }
  },
  computed: {
    validate () {
      return this.clientName.length > 0
    },
    brandName () {
      return this.$store.getters[`${this.vuexNamespace}/${callCenterGetters.BRAND_NAME}`]
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/CreateClientProfile.vue